export default __webpack_public_path__ + "static/media/authors.be3a7b9b.svg";